import IntranetLayout from "@/components/IntranetLayout";
import CrewTransferIntelligenceTool from "@/pages/CrewTransferIntelligence";

const EmployeeCrewTransferIntelligence = () => {
  return (
    <IntranetLayout>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-[#00283C] font-display">Crew Transfer Intelligence</h1>
        <p className="text-sm text-muted-foreground">
          Helicopter vs CTV cost comparator with live Jet A-1 / MGO fuel pricing, weather operability and branded prospect reports.
        </p>
      </div>
      <CrewTransferIntelligenceTool skipGate skipLayout />
    </IntranetLayout>
  );
};

export default EmployeeCrewTransferIntelligence;
